
(function () {
  const drawer = document.querySelector('[data-mobile-drawer]');
  const openBtn = document.querySelector('[data-drawer-toggle]');
  const closeBtn = document.querySelector('[data-drawer-close]');
  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  };
  if (openBtn) openBtn.addEventListener('click', () => setDrawer(true));
  if (closeBtn) closeBtn.addEventListener('click', () => setDrawer(false));
  if (drawer) drawer.addEventListener('click', (event) => {
    if (event.target === drawer) setDrawer(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setDrawer(false);
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('[data-gallery-main]');
      if (main && thumb.dataset.full) {
        main.src = thumb.dataset.full;
        main.alt = thumb.alt || main.alt;
      }
    });
  });
})();

(function () {
  document.querySelectorAll('[data-wdn-slider-wrap]').forEach((wrap) => {
    const slider = wrap.querySelector('[data-wdn-slider]');
    if (!slider) return;
    const scrollSlider = (direction) => {
      const firstCard = slider.children[0];
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : slider.clientWidth * 0.75;
      slider.scrollBy({ left: direction * (cardWidth + 12), behavior: 'smooth' });
    };
    const prev = wrap.querySelector('[data-slider-prev]');
    const next = wrap.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', () => scrollSlider(-1));
    if (next) next.addEventListener('click', () => scrollSlider(1));
  });
})();
